const options = {
  future: {
    v7_relativeSplatPath: true,
    v7_partialHydration: true,
    v7_startTransition: true
  }
};

export { options };